import { defineStore } from 'pinia';
import Network from "~/utils/network";

const urls = {
    banks: (locale) => `/api/psd2/content/${locale}/banks.json`,
    bankGuideByBankId: (locale, bankId) => `/api/psd2/content/${locale}/banks/${bankId}/guides.json`,
    b2bBanks: (locale) => `/api/psd2/content/${locale}/b2b/banks.json`,
    b2bBankGuideByBankId: (locale, bankId) => `/api/psd2/content/${locale}/b2b/banks/${bankId}/guides.json`
};

/**
 * The bank list and the per-bank guides, which are content rather than state.
 *
 * Where the customer is inside the PSD2 screens used to live here too, so that
 * the B2B pages could read it from outside the component. They ask the
 * component now, and a step counter shared by every PSD2 screen in the app was
 * never anything but a way for two of them to disagree.
 *
 * Nothing awaits these, so a failure is logged rather than rethrown: content
 * that will not load must not surface as an unhandled rejection.
 */
export const usePsd2FlowStore = defineStore('psd2Flow', {
    state: () => ({
        banks: [],
        bankGuides: [],
    }),
    actions: {
        fetchBanks: async function (locale, isB2b = false) {
            let url = isB2b ? urls.b2bBanks(locale) : urls.banks(locale);
            try {
                this.banks = await Network.http(useRuntimeConfig().public.olmScmsBaseUrl + url, { method: 'GET' });
                this.banks.sort((a, b) => a.id - b.id);
            } catch (err) {
                console.log("PSD2:: could not load the bank list", err);
            }
        },
        fetchBankGuidesByBankId: async function (locale, bankId, isB2b = false) {
            let url = isB2b ? urls.b2bBankGuideByBankId(locale, bankId) : urls.bankGuideByBankId(locale, bankId);
            try {
                this.bankGuides = await Network.http(useRuntimeConfig().public.olmScmsBaseUrl + url, { method: 'GET' });
            } catch (err) {
                console.log("PSD2:: could not load the bank guides", err);
            }
        },
    },
});
